export default {
  setAccountingCodeList(state, accountingCodeList){
    state.accountingCodeList = accountingCodeList
  },
  setAccountingCode(state, accountingCode){
    state.accountingCode = accountingCode
  },

}
